import { Button } from "~/common/components/Button/Button";

interface Props {
  label: string;
  href: string;
}

export function create(props: Props) {
  return <Button href={props.href}>{props.label}</Button>;
}
